import service from "@/utils/request";

export function getInputtipsApi(data) {
    return service({
        url: "/lbs/inputtips",
        method: "get",
        params: data,
    });
}
